const passwordResetModel = {
    formId: 'passwordResetForm',
    formField: {
      password: {
        name: 'password',
        label: 'New Password',
        required: true,
        inputType: 'password',
        requiredErrorMsg: 'Please enter your new password',
        invalidErrorMsg: 'Password must be at least 8 characters',
      },
      confirmPassword: {
        name: 'confirmPassword',
        label: 'Confirm Password',
        required: true,
        inputType: 'password',
        requiredErrorMsg: 'Please re-enter your password',
        invalidErrorMsg: 'Passwords must match',
      }
    },
    initialValues: {
        password: '',
        confirmPassword: '',
    }
};

export type passwordResetModelType = {
    password: string,
    confirmPassword: string,
}

export default passwordResetModel
